import React from 'react'
import Media from 'react-media'

import MS20Portrait from './MS20Portrait'
import MS20Landscape from './MS20Landscape'

const HomeMenuBG = () => (
	<Media query="(min-width: 801px) and (orientation: landscape)">
    { matches => matches ? <MS20Landscape/> : <MS20Portrait/> }
	</Media>
)

export default HomeMenuBG


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/menuModal/MenuBG.js